// keep this while we developing, we can remove or setup logger in here later
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    console.error('errorHandler', error, info);
  };
  nuxtApp.hook('vue:error', (error, instance, info) => {
    console.error('vue:error', error, info);
  });
});
